"use strict";

var _interopRequireDefault = require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.constantRoutes = void 0;
require("core-js/modules/es.object.to-string.js");
var _interopRequireWildcard2 = _interopRequireDefault(require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/interopRequireWildcard.js"));
var _vue = _interopRequireDefault(require("vue"));
var _vueRouter = _interopRequireDefault(require("vue-router"));
var _layout = _interopRequireDefault(require("@/layout"));
var _settings = require("@/settings");
/* Layout */

_vue.default.use(_vueRouter.default);

/**
 * Note: 路由配置项
 *
 * hidden: true                   // 当设置 true 的时候该路由不会再侧边栏出现 如401，login等页面，或者如一些编辑页面/edit/1
 * alwaysShow: true               // 当你一个路由下面的 children 声明的路由大于1个时，自动会变成嵌套的模式--如组件页面
 *                                // 只有一个时，会将那个子路由当做根路由显示在侧边栏--如引导页面
 *                                // 若你想不管路由下面的 children 声明的个数都显示你的根路由
 *                                // 你可以设置 alwaysShow: true，这样它就会忽略之前定义的规则，一直显示根路由
 * redirect: noRedirect           // 当设置 noRedirect 的时候该路由在面包屑导航中不可被点击
 * name:'router-name'             // 设定路由的名字，一定要填写不然使用<keep-alive>时会出现各种问题
 * meta : {
    roles: ['admin','editor']    // 设置该路由进入的权限，支持多个权限叠加
    title: 'title'               // 设置该路由在侧边栏和面包屑中展示的名字
    icon: 'svg-name'             // 设置该路由的图标，对应路径src/icons/svg
    breadcrumb: false            // 如果设置为false，则不会在breadcrumb面包屑中显示
  }
 */

// 公共路由
var constantRoutes = exports.constantRoutes = [{
  path: '/redirect',
  component: _layout.default,
  hidden: true,
  children: [{
    path: '/redirect/:path(.*)',
    component: function component(resolve) {
      return require(['@/views/redirect'], resolve);
    }
  }]
}, /* 登陆区 */
{
  path: '/entry',
  hidden: true,
  component: function component(resolve) {
    return require(['@/views/entry'], resolve);
  },
  // redirect : '/login',
  children: [
  // { path: '/login', hidden: true, component: (resolve) => require(['@/views/entry/components/login'], resolve) },
  {
    path: '/register',
    hidden: true,
    component: function component(resolve) {
      return require(['@/views/entry/components/register'], resolve);
    }
  }]
},
// { path: '/dpView', hidden: true, component: (resolve) => require(['@/views/business/trace/dpView/index'], resolve) },
// { path: '/tableShow', hidden: true, component: (resolve) => require(['@/views/test/tableShow/tableShow'], resolve) },
{
  path: '/login',
  hidden: true,
  component: function component(resolve) {
    return require(['@/views/login'], resolve);
  }
}, {
  path: '/404',
  hidden: true,
  component: function component(resolve) {
    return require(['@/views/error/404'], resolve);
  }
}, {
  path: '/401',
  hidden: true,
  component: function component(resolve) {
    return require(['@/views/error/401'], resolve);
  }
}, {
  path: '',
  component: _layout.default,
  redirect: 'index',
  children: [{
    path: 'index',
    component: function component(resolve) {
      var indexStyle = require('@/settings.js').indexStyle;
      if (indexStyle === 1) {
        require(['@/views/business/home1/index'], resolve);
      } else if (indexStyle === 2) {
        require(['@/views/business/home2/index'], resolve);
      } else {
        require(['@/views/business/home/index'], resolve);
      }
    },
    name: '首页',
    meta: {
      title: '首页',
      icon: 'dashboard',
      noCache: true,
      affix: true
    }
  }]
}, {
  path: '/user',
  component: _layout.default,
  hidden: true,
  redirect: 'noredirect',
  children: [{
    path: 'profile',
    component: function component(resolve) {
      return require(['@/views/system/user/profile/index'], resolve);
    },
    name: 'Profile',
    meta: {
      title: '个人中心',
      icon: 'user'
    }
  }]
}, {
  path: '/dict',
  component: _layout.default,
  hidden: true,
  children: [{
    path: 'type/data/:dictId(\\d+)',
    component: function component(resolve) {
      return require(['@/views/system/dict/data'], resolve);
    },
    name: 'Data',
    meta: {
      title: '字典数据',
      icon: ''
    }
  }]
}, {
  path: '/all-files-preview',
  component: function component() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require('@/components/wl-business-component/sopComponents/pageFileView/allFilesPreview'));
    });
  },
  name: 'AllFilesPreview',
  hidden: true
}];
var _default = exports.default = new _vueRouter.default({
  mode: 'history',
  // 去掉url中的#
  scrollBehavior: function scrollBehavior() {
    return {
      y: 0
    };
  },
  routes: constantRoutes
});